module.exports = __webpack_public_path__ + "static/img/report_img_bjstggaqnb.e282ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_bjstggaqnb.png
// module id = ZAgY
// module chunks = 21